module.exports = __webpack_public_path__ + "static/badge_non_verified-afa700d287979ae20c826fc50b03f90f.svg";